import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const CardContainer = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isActive";
  },
})<{ isActive?: boolean }>(({ isActive }) => ({
  display: "flex",
  gap: "0 6px",
  alignItems: "center",
  color: isActive ? colors.gray600 : colors.gray400,
}));

export const CardInfosContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0 6px",
  padding: "0 4px",
}));

export const ImageWrapper = styled("div")(() => ({
  padding: "8px",
}));
